import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var Font = /** @class */ (function (_super) {
    __extends(Font, _super);
    function Font() {
        var _this = _super.call(this) || this;
        _this.isAVMFont = true;
        _this.isAVMFont = true;
        return _this;
    }
    Object.defineProperty(Font.prototype, "fontName", {
        get: function () {
            return this._fontName;
        },
        set: function (value) {
            this._fontName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Font.prototype, "fontStyle", {
        get: function () {
            console.warn('`Font#get:fontStyle` not implement yet');
            return 'regular';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Font.prototype, "fontType", {
        get: function () {
            console.warn('`Font#get:fontType` not implement yet');
            return 'embedded';
        },
        enumerable: true,
        configurable: true
    });
    Font.enumerateFonts = function (enumerateDeviceFonts) {
        if (enumerateDeviceFonts === void 0) { enumerateDeviceFonts = false; }
        console.warn('`Font.enumerateFonts` not implement yet');
        return [];
    };
    Font.registerFont = function (font) {
        console.warn('`Font.registerFont` not implement yet');
    };
    Font.prototype.hasGlyphs = function (str) {
        console.warn('`Font#hasGlyphs` not implement yet');
        return false;
    };
    Font.forceNativeConstructor = true;
    Font.forceNativeMethods = true;
    Font.classInitializer = null;
    Font.classSymbols = null;
    Font.instanceSymbols = null;
    return Font;
}(ASObject));
export { Font };
